import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { CompanyConfig } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CompanyConfigsService {
  private readonly baseUrl = environment.apiUrl || 'http://localhost:3000';

  constructor(private http: HttpClient) {}

  /**
   * Retorna as configurações da empresa do usuário autenticado
   */
  getCurrentCompanyConfig(): Observable<CompanyConfig> {
    return this.http.get<CompanyConfig>(`${this.baseUrl}/company/configs`);
  }

  /**
   * Retorna as configurações de uma empresa específica (uso do admin)
   */
  getCompanyConfig(companyId: string | number): Observable<CompanyConfig> {
    return this.http.get<CompanyConfig>(`${this.baseUrl}/companies/${companyId}/configs`);
  }

  /**
   * Atualiza as configurações de uma empresa específica
   */
  updateCompanyConfig(
    companyId: string | number,
    payload: Partial<CompanyConfig>,
  ): Observable<CompanyConfig> {
    return this.http.patch<CompanyConfig>(
      `${this.baseUrl}/companies/${companyId}/configs`,
      payload,
    );
  }
}
